import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FloorTabs from './components/floor-tabs';
import MapView from './components/map-view';

// TODO: Fetch available floors dynamically if needed
const AVAILABLE_FLOORS = [1, 2]; // Assuming floors 1 and 2 exist for now

const MapPage: React.FC = () => {
  const { t } = useTranslation();
  const [selectedFloor, setSelectedFloor] = useState<number>(AVAILABLE_FLOORS[0]);

  // Construct the image URL based on the selected floor
  // Ensure your image naming convention matches this (e.g., floor_1.svg)
  const mapImageUrl = `/images/maps/floor_${selectedFloor}.svg`; // Changed extension to .svg
  const mapAltText = t('map.floorAltText', 'Floor {{floor}} Map', { floor: selectedFloor });

  return (
    <div className="container mx-auto p-4 py-8 md:p-8">
      <h1 className="mb-6 text-3xl font-bold md:text-4xl">
        {t('map.title', 'Museum Map')}
      </h1>

      <div className="flex flex-col gap-6">
        <FloorTabs
          availableFloors={AVAILABLE_FLOORS}
          selectedFloor={selectedFloor}
          onFloorChange={setSelectedFloor}
        />
        <MapView imageUrl={mapImageUrl} altText={mapAltText} />
      </div>
    </div>
  );
};

export default MapPage;
